/**
 * @hidden
 */
export enum TreeLinkTypes {
    Link = 1,
    Script = 2,
    Command = 3,
    Commandprep = 4,
    IconCssClass = 5
}
